import hasClass from "./hasClass";

const removeClass = function (ele, cls) {
    if (hasClass(ele, cls)) {
        const reg = new RegExp(`(\\s|^)${cls}(\\s|$)`);
        ele.className = ele.className.replace(reg, ' ');
    }
};
export default removeClass;
